import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScAuroraPanel = styled.div`
  position: relative;
  display: flex;
  height: 80px;
  border-radius: 8px;
  background: ${({ theme }) => theme.grayColor6};
  overflow: hidden;
  cursor: pointer;

  & .desktop {
    @media (${device.mobile}) {
      display: none;
    }
  }

  & .mobile {
    display: none;

    @media (${device.mobile}) {
      display: block;
    }
  }

  & .bg {
    position: absolute;
    left: -20px;
    bottom: -96px;
    width: 190px;
    height: 190px;

    @media (${device.mobile}) {
      width: 430px;
      height: auto;
      left: -21px;
      bottom: -224px;
    }
  }

  & .inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 12px;
    z-index: 2;
  }

  & .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }

  & .content-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    @media (${device.mobile}) {
      align-items: center;
      flex-direction: row;
      gap: 8px;
    }
  }

  & .title {
    display: flex;
    align-items: center;
    gap: 4px;

    & > p {
      color: ${({ theme }) => theme.whiteColor};
      font-size: 10px;
      font-style: normal;
      font-weight: 700;
      line-height: 14px;
      letter-spacing: 0;

      @media (${device.mobile}) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }

  & .display {
    position: relative;
    width: 32px;
    height: 32px;

    @media (${device.mobile}) {
      width: 56px;
      height: 56px;
    }

    & img {
      width: 100%;
      flex-shrink: 0;
      aspect-ratio: 1/1;
    }

    & .background {
      position: absolute;
      z-index: 2;
    }

    & .prize {
      position: absolute;
      z-index: 3;
      width: 20px;
      height: 20px;
      top: 50%;
      right: 50%;
      transform: translate(50%, -50%);

      @media (${device.mobile}) {
        width: 34px;
        height: 34px;
      }
    }

    & .foreground {
      position: absolute;
      z-index: 4;
      bottom: 0;
      left: 0;
      transition: bottom 0.3s ease-in-out;
    }
  }

  & .message-2 {
    color: ${({ theme }) => theme.whiteColor};
    text-align: center;
    font-size: 8px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0;
  }
`;
